<template>
  <div class="min-vh-100 d-flex flex-column">
    <Nav />
    <div class="container-xl">
      <div class="flex-grow-1 d-flex">
        <transition
          name="fade"
          mode="out-in"
        >
          <router-view />
        </transition>
      </div>
    </div>
    <footer class="footer mt-auto">
      <img
        src="@/assets/dinamix-logo.png"
        alt=""
      >
    </footer>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import Sidebar from '@/components/Sidebar'

export default {
  components: { Nav, Sidebar }
}
</script>
